let counter = 0;

function getId() {
    return ++counter;
}

export default getId;
